import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import {checkDevice} from  '@/utils/checkDevice'
let path;
if(checkDevice()){
  path="mobild"
}else{
  path="pc"
}
export default new Router({
  routes: [
    {
      path: '/',
      component: (resolve) => require([`@/components/${path}/home`], resolve),
      redirect: '/index'
    },
    {
      path: '/',
      component: (resolve) => require([`@/components/${path}/home`], resolve),
      children: [
        {
          path: 'index',
          component: (resolve) => require([`@/components/${path}/index`], resolve),
          // component: (resolve) => require([`@/components/reactinVue/test`], resolve),
          name: 'index'
        },
        {
          path: 'bridge',
          component: () => window.open("https://cbridge.celer.network/"),
          // component: (resolve) => require([`@/components/reactinVue/test`], resolve),
          name: 'bridge'
        },
        {
          path: 'voting',
          component: () => window.open("https://snapshot.org/#/daostarter2021.eth"),
          // component: (resolve) => require([`@/components/reactinVue/test`], resolve),
          name: 'voting'
        },
        {
          path: 'Labs',
          component: () => window.open("https://labs.daostarter.pro/"),
          // component: (resolve) => require([`@/components/reactinVue/test`], resolve),
          name: 'Labs'
        },
        /*{
          path: 'swap',
          component: (resolve) => require([`@/components/${path}/swap`], resolve),
          // component: (resolve) => require([`@/components/reactinVue/test`], resolve),
          name: 'swap'
        },*/
        {
          path: 'nfts',
          component: (resolve) => require([`@/components/${path}/pools`], resolve),
          name: 'nfts'
        },
        {
          path: 'profile',
          component: (resolve) => require([`@/components/${path}/profile`], resolve),
          name: 'profile'
        },
        {
          path: 'pools',
          component: (resolve) => require([`@/components/${path}/pools`], resolve),
          name: 'pools'
        },
        {
          path: 'submitYourProjects',
          component: (resolve) => require([`@/components/${path}/submitYourProjects`], resolve),
          name: 'submitYourProjects'
        },
        {
          path: 'aboutUs',
          component: (resolve) => require([`@/components/${path}/aboutUs`], resolve),
          name: 'aboutUs'
        },
        {
          path: 'saleDetail',
          component: (resolve) => require([`@/components/${path}/galaxyFightClub`], resolve),
          name: 'galaxyFightClub'
        },
        {
          path: 'inoDetial',
          component: (resolve) => require([`@/components/${path}/dragonarySummerNFTBox`], resolve),
          name: 'dragonarySummerNFTBox'
        },
        {
          path: 'termsConditions',
          component: (resolve) => require([`@/components/${path}/terms&Conditions`], resolve),
          name: 'terms&termsConditions'
        },
        {
          path: 'dragonarySummerNFTBox',
          component: (resolve) => require([`@/components/${path}/dragonarySummerNFTBox`], resolve),
          name: 'dragonarySummerNFTBox'
        }
      ]
    }
  ],
  scrollBehavior: () => ({ y: 0 })
})



// WEBPACK FOOTER //
// ./src/router/index.js